

























































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'

// services
import { AfpService } from '@/services/config'

// Models
import { Paginator } from '@/models'
import { AfpModel, FiltersAfp, AfpList } from '@/models/config'

@Component({
    name: 'TableListAfps',
    components: {
        DataTable,
        IsActive
    }
})
export default class TableListAfps extends Vue {
    @Prop({ required: true, type: Object }) filters!: FiltersAfp
    loading = false
    items: AfpModel[] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'name',
            sortable: true,
            label: 'AFP'
        },
        {
            key: 'percentage_flow',
            sortable: true,
            label: 'Porcentaje Flujo (%)'
        },
        {
            key: 'mixed_percentage',
            sortable: true,
            label: 'Porcentaje Mixto (%)'
        },
        {
            key: 'contribution',
            sortable: true,
            label: 'Aporte Obligatorio (%)'
        },
        {
            key: 'insurance_premium',
            sortable: true,
            label: 'Prima Seguro (%)'
        },
        {
            key: 'safe_stop',
            sortable: true,
            label: 'Tope Seguro'
        },
        {
            key: 'status_text',
            sortable: true,
            label: 'Status'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '15%'
            }
        }
    ]

    created () {
        this.getAfpsWithPagination()
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getAfpsWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getAfpsWithPagination()
    }

    edit (itemId: number) {
        const item = this.items.find(i => i.id === itemId)
        this.$emit('edit-item', item)
    }

    async getAfpsWithPagination () {
        this.loading = true
        const response = await AfpService.getWithPagination(this.pagination.perPage, this.pagination.currentPage)
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
    }

    get itemsFormat (): AfpList[] {
        return this.items.map(item => {
            const itemDetail = item.items.find(i => i.year === this.filters.year && i.month === this.filters.month)
            const _item: AfpList = {
                name: item.name,
                percentage_flow: 0,
                mixed_percentage: 0,
                contribution: 0,
                insurance_premium: 0,
                safe_stop: 0,
                status_text: item.status_text,
                id: item.id,
                is_active: item.is_active
            }
            if (itemDetail) {
                _item.percentage_flow = itemDetail.percentage_flow
                _item.mixed_percentage = itemDetail.mixed_percentage
                _item.contribution = itemDetail.contribution
                _item.insurance_premium = itemDetail.insurance_premium
                _item.safe_stop = itemDetail.safe_stop
            }
            return _item
        })
    }
}
